/**
 * Configuration centralisée de l'application
 * Charge toutes les variables d'environnement et fournit des valeurs par défaut
 */

export interface AppConfig {
  api: {
    url: string;
    timeout: number;
  };
  app: {
    name: string;
    version: string;
    debug: boolean;
  };
  environment: 'development' | 'production' | 'test';
}

/**
 * Configuration de l'application basée sur les variables d'environnement
 */
const config: AppConfig = {
  api: {
    url: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10),
  },
  app: {
    name: process.env.REACT_APP_APP_NAME || 'Random Message App',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    debug: process.env.REACT_APP_DEBUG === 'true',
  },
  environment: (process.env.NODE_ENV as 'development' | 'production' | 'test') || 'development',
};

/**
 * Fonction utilitaire pour logger la configuration en mode debug
 */
export const logConfig = (): void => {
  if (config.app.debug) {
    console.group('🔧 Configuration de l\'application');
    console.log('Environment:', config.environment);
    console.log('API URL:', config.api.url);
    console.log('API Timeout:', config.api.timeout);
    console.log('App Name:', config.app.name);
    console.log('App Version:', config.app.version);
    console.log('Debug Mode:', config.app.debug);
    console.groupEnd();
  }
};

/**
 * Fonction utilitaire pour valider la configuration
 */
export const validateConfig = (): boolean => {
  const errors: string[] = [];

  if (!config.api.url) {
    errors.push('API URL is required');
  }

  if (config.api.timeout <= 0) {
    errors.push('API timeout must be positive');
  }

  if (!config.app.name) {
    errors.push('App name is required');
  }

  if (errors.length > 0) {
    console.error('❌ Configuration errors:', errors);
    return false;
  }

  return true;
};

// Validation automatique de la configuration
if (config.app.debug) {
  validateConfig();
  logConfig();
}

export default config;
